export default __webpack_public_path__ + "static/media/cocina.171cda8d.png";